import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { createUseStyles } from "react-jss";
import SearchFilter from "./components/SearchFilter";
import { SearchMachineContent } from "../../../services/dto/machine";

const useStyles = createUseStyles({
  container: {
    padding: "20px",
    background: "#fff",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "50px",
  },
  searchContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    marginBottom: 60,
  },
  tableContainer: {
    marginTop: "20px",
  },
  addButton: {
    borderColor: "#1890ff",
    color: "#1890ff",
    "&:hover": {
      borderColor: "#40a9ff",
      color: "#40a9ff",
    },
  },
  link: {
    color: "#1890ff",
    cursor: "pointer",
    textDecoration: "underline",
  },
  footerContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
});

export default function MachineSearch() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState<SearchMachineContent[]>([]);
  const [multipleDeleteData, setMulitpleDeleteData] = useState<
    SearchMachineContent[]
  >([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const columns = [
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
      render: (text: string, record: any) => (
        <span
          className={classes.link}
          onClick={() =>
            navigate(`/machine/detail`, { state: { data: record } })
          }
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.code.localeCompare(b.code),
    },
    {
      title: "Kode Tipe Mesin",
      dataIndex: "machineTypeCode",
      key: "machineTypeCode",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: "Nama Tipe Mesin",
      dataIndex: "machineTypeName",
      key: "machineTypeName",
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },

    {
      title: "Action",
      key: "action",
      render: (record: any) => (
        <Space size="middle">
          <EditOutlined
            onClick={() =>
              navigate(`/machine/edit/input`, { state: { data: record } })
            }
          />
          <DeleteOutlined
            onClick={() =>
              navigate(`/machine/delete/review`, { state: { data: record } })
            }
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: SearchMachineContent[]
  ) => {
    setSelectedRowKeys(newSelectedRowKeys as string[]);
    setMulitpleDeleteData(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <h2>Machine</h2>
        <Button
          ghost={true}
          type="primary"
          onClick={() => navigate("/machine/add/input")}
          className={classes.addButton}
        >
          Add
        </Button>
      </div>
      <SearchFilter setData={setData} initSearch={true} />
      <div className={classes.tableContainer}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="code"
          rowSelection={rowSelection}
          scroll={{ x: true }}
          pagination={{
            position: ["bottomRight"],
            pageSizeOptions: ["10", "50", "100"],
            showSizeChanger: true,
            defaultPageSize: 10,
          }}
        />
      </div>
      <div className={classes.footerContainer}>
        {selectedRowKeys.length > 0 && (
          <Button
            type="primary"
            onClick={() =>
              navigate("/machine/multiple-delete/review", {
                state: { data: multipleDeleteData },
              })
            }
            danger={true}
          >
            Delete
          </Button>
        )}
      </div>
    </div>
  );
}
